// packages/sim/src/data.ts
export const factionDefaults: Record<
  string,
  {
    name: string;
    names?: Record<string, string>;
    buildings: string[];
    units: string[];
    startBuilding: string;
    startUnit: string;
    buildOrder: string[];
    army: string[];
  }
> = {
  bastion: {
    name: "Razmak",
    names: {
      helipad: "Airfield",
      reconDrone: "Recon drone",
      strikeDrone: "Attack drone",
    },
    buildings: [
      "headquarters",
      "generator",
      "depot",
      "quarters",
      "factory",
      "tower",
      "bunker",
      "wall",
      "tradePost",
      "radar",
      "helipad",
      "samSite",
      "silo",
    ],
    units: [
      "builder",
      "hauler",
      "rifleman",
      "grenadier",
      "rocketeer",
      "engineer",
      "buggy",
      "strider",
      "hoverBattery",
      "bombard",
      "petrel",
      "reconDrone",
      "strikeDrone",
    ],
    startBuilding: "headquarters",
    startUnit: "builder",
    buildOrder: [
      "generator",
      "depot",
      "quarters",
      "factory",
      "tower",
      "bunker",
      "tradePost",
      "radar",
      "samSite",
      "helipad",
      "silo",
    ],
    army: [
      "rifleman",
      "grenadier",
      "rocketeer",
      "buggy",
      "strider",
      "hoverBattery",
      "bombard",
      "petrel",
    ],
  },
};

export const armorDefaults = ["infantry", "light", "heavy", "building"];
